import React, { Component } from 'react';
import { Row, Col, Button, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import './style.css';
class Tarot extends Component {
    render() {
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        console.log("coutryCode",countryCode)

        return (
            <Container>
                <Row>
                    <Col className="tarot">
                        <div className="tarot-bg">
                            <div>
                                <h1><FormattedMessage id="main.tarot.title"
                                    defaultMessage="Tarot Cards"
                                    description=""
                                    values={""} /></h1>
                                <p className={countryCode.countryCode==="nl" ? "tarot-bg-p":null}><FormattedMessage id="main.tarot.paragraph"
                                    defaultMessage="The Tarot is the most practiced art of divination in the World and with every good reason."
                                    description=""
                                    values="" />
                                </p>
                                <div className="tarot-margin-top">
                                    <Link to="/tarotreading"><Button onClick={this.handleTarotReading} outline className="tarot-btn">
                                        <FormattedMessage id="main.tarot.button"
                                            defaultMessage="View Yours Now"
                                            description=""
                                            values="" /></Button></Link>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}
export default Tarot;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarot/tarot.js